import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums';

const CreateCriteriaType = (param: any) =>
    request({
        url: ApiURL.Command.CreateCriteriaType,
        method: RequestType.POST,
        data: param,
    });
const GetCriteriaTypeList = (param: any) =>
    request({
        url: ApiURL.Command.GetCriteriaTypeList,
        method: RequestType.POST,
        data: param,
    });
const GetRuleTemplateList = (param: any) =>
    request({
        url: ApiURL.Command.GetRuleTemplateList,
        method: RequestType.POST,
        data: param,
    });
const CreateRule = (param: any) =>
    request({
        url: ApiURL.Command.CreateRule,
        method: RequestType.POST,
        data: param,
    });
const GetRuleList = (param: any) =>
    request({
        url: ApiURL.Command.GetRuleList,
        method: RequestType.POST,
        data: param,
    });

const CreateRuleTemplate = (param: any) =>
    request({
        url: ApiURL.Command.CreateRuleTemplate,
        method: RequestType.POST,
        data: param,
    });
const CriteriaTypeDelete = (param: any) =>
    request({
        url: ApiURL.Command.CriteriaTypeDelete,
        method: RequestType.DELETE,
        data: param,
    });
const DeleteRuleTemplate = (param: any) =>
    request({
        url: ApiURL.Command.DeleteRuleTemplate,
        method: RequestType.DELETE,
        data: param,
    });
const RuleServiceCommand = {
    CreateCriteriaType,
    CreateRuleTemplate,
    GetRuleTemplateList,
    GetCriteriaTypeList,
    CreateRule,
    GetRuleList,
    CriteriaTypeDelete,
    DeleteRuleTemplate,
};

export default RuleServiceCommand;
